import React from "react";
import { Constants, helpers } from "@shared";
import PropTypes from 'prop-types';

const PaymentDay = ({ maxDay, dueDay, setDueDay, locked, isAutopayLate }) => {

    const days = [];
    for (let i = 1; i <= maxDay; i++) days.push(<option key={`${i}day`} value={i}>On the {helpers.dayOrdinal(i)}</option>);

    return (
        <div className="flex flex-col gap-y-3" >
            <div className="text-gray-500 font-bold">
                Your Payment Day:
            </div>
            <div>
                <select disabled={locked}
                    id="autopay-day-selector"
                    className="mt-1 block w-full rounded-md border-gray-300 py-3 pl-3 pr-10 text-2xl focus:outline-none disabled:bg-gray-400"
                    value={dueDay ?? ``}
                    onChange={(e) => {
                        setDueDay(parseInt(e.target.value));
                    }} aria-label="Default select example">
                    {days}
                </select>
            </div>
            {
                isAutopayLate &&
                <div id="autopay-late-alert">
                    <span className="text-red-500">Your auto-draw day is in the past. If you have an outstanding balance, please make a one-time payment for this month’s balance.</span>
                </div>
            }
            <div>
                <a className="text-blue-over" href={Constants.Help.PaymentDay} target='_blank' rel="noreferrer">Can I change my payment day?</a>
            </div>
            <div className="text-gray-500">
                ACH payments will process the business day before to ensure it goes through on time.
            </div>
        </div >
    );
};

PaymentDay.propTypes = {
    dueDay: PropTypes.number,
    setDueDay: PropTypes.func.isRequired,
    locked: PropTypes.bool,
    maxDay: PropTypes.number.isRequired,
    isAutopayLate: PropTypes.bool
};

PaymentDay.defaultProps = {
    locked: false,
    isAutopayLate: false
};

export default PaymentDay;
